<template>
  <a-modal
      :open="open"
      :body-style="bodyStyle"
      title="选择用户编号"
      width="75%"
      :mask-closable="false"
      centered
      @ok="selectOnOk"
      @cancel="selectOnCancel"
  >
    <a-form
        class="form"
        ref="searchFormRef"
        :model="searchFormValue"
        :rules="searchFormRules"
        @finish="searchFormFinish"
        @finishFailed="searchFormFinishFailed"
    >
      <a-row :gutter="24">
        <a-col :span="5">
          <a-form-item label="所属水司" name="waterCompany">
            <a-select
                v-model:value="searchFormValue.waterCompany"
                :options="waterCompanyOptions"
                placeholder="请选择所属水司"
                allowClear
            >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="查询条件" name="queryCriteria">
            <a-select
                v-model:value="searchFormValue.queryCriteria"
                :options="queryCriteriaOptions"
                placeholder="请选择查询条件"
                allowClear
            >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="14">
          <a-form-item label="查询内容" name="queryContent">
            <a-input
                v-model:value="searchFormValue.queryContent"
                :options="queryCriteriaOptions"
                placeholder="请选择查询内容"
                allowClear
            >
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col class="btn-group" :span="24">
          <a-button @click="searchFormResetButtonOnClick()">清空</a-button>
          <a-button type="primary" html-type="submit">查询</a-button>
        </a-col>
      </a-row>
    </a-form>
    <a-spin :spinning="loading" tip="加载中">
      <vxe-table
          class="table"
          height="400px"
          ref="userTableRef"
          :data="userTableData.userInfoList"
          :checkbox-config="{
            highlight: true
          }"
      >
        <vxe-column type="checkbox" width="60" fixed="left"></vxe-column>
        <vxe-column field="waterCompany" title="所属水司" width="150" fixed="left"></vxe-column>
        <vxe-column field="userNumber" title="用户编号" width="100" fixed="left"></vxe-column>
        <vxe-column field="userPracticalName" title="用户实际名称" width="200"></vxe-column>
        <vxe-column field="userPracticalAddress" title="用户实际地址" width="300"></vxe-column>
        <vxe-column field="userCertificateName" title="用户证件名称" width="200"></vxe-column>
        <vxe-column field="userCertificateAddress" title="用户证件地址" width="300"></vxe-column>
        <vxe-column field="mobileTelephone" title="移动电话" width="150"></vxe-column>
        <vxe-column field="fixedLineTelephone" title="固定电话" width="150"></vxe-column>
        <vxe-column field="paymentMethod" title="交费方式" width="150"></vxe-column>
        <vxe-column field="waterCardNumber" title="水卡号码" width="150"></vxe-column>
        <vxe-column field="email" title="电子邮箱" width="150"></vxe-column>
        <vxe-column field="userStatus" title="用户状态" width="150"></vxe-column>
        <vxe-column field="userServiceStatus" title="用户服务状态" width="150"></vxe-column>
      </vxe-table>
    </a-spin>
  </a-modal>
</template>

<script setup>
import {reactive, ref, onMounted, defineModel} from "vue";
import {message, Modal} from "ant-design-vue";
import {useStore} from "vuex";

import globalComponentBatchSelectUsersApi from "@/api/global-component/batch-select-users";

const emits = defineEmits(['selectFinish']);

const store = useStore();

const bodyStyle = {
  height: '550px',
  padding: '10px 15px',
  overflow: 'hidden',
  overflowY: 'scroll',
}

const open = defineModel("open")

const loading = ref(false);

const waterCompanyOptions = ref([]);
const queryCriteriaOptions = ref([
  {
    value: "用户编号",
    label: "用户编号"
  },
  {
    value: "用户实际名称",
    label: "用户实际名称"
  },
  {
    value: "用户实际地址",
    label: "用户实际地址"
  },
  {
    value: "用户证件名称",
    label: "用户证件名称"
  },
  {
    value: "用户证件地址",
    label: "用户证件地址"
  },
  {
    value: "移动电话",
    label: "移动电话"
  },
  {
    value: "固定电话",
    label: "固定电话"
  },
  {
    value: "水卡条码",
    label: "水卡条码"
  },
  {
    value: "银行账号",
    label: "银行账号"
  },
  {
    value: "电子邮箱",
    label: "电子邮箱"
  },
]);

const searchFormRef = ref({});
const searchFormValue = reactive({
  waterCompany: undefined,
  queryCriteria: undefined,
  queryContent: undefined
});
const searchFormRules = {
  waterCompany: [{required: true, message: '请选择所属水司'}],
  queryCriteria: [{required: true, message: '请选择查询条件'}],
  queryContent: [{required: true, message: '请选择查询内容'}]
}

const userTableRef = ref();
const userTableData = reactive({
  userInfoList: []
});

// 初始化所属水司选项
const initWaterCompanyOptions = () => {
  const allWaterCompany = ['番禺水务', '钟村水司', '石碁水司', '东乡水司', '南村水司', '大石营业部', '沙湾营业部', '莲泉水司', '新造水司', '化龙水司'];
  const accountWaterCompany = store.state.accountInfo.waterCompany;
  if (accountWaterCompany === "全部水司") {
    let options = [];
    for (let index in allWaterCompany) {
      options.push({key:index, value: allWaterCompany[index], label: allWaterCompany[index]});
    }
    waterCompanyOptions.value = options;
  } else {
    waterCompanyOptions.value = [
      {value: accountWaterCompany, label: accountWaterCompany}
    ];
    searchFormValue.waterCompany = accountWaterCompany;
  }
}

onMounted(() => {
  initWaterCompanyOptions();
})

const searchFormResetButtonOnClick = () => {
  searchFormRef.value.resetFields();
}

const searchFormFinishFailed = (error) => {
  let errorMsgArray = [];
  const errorFields = error.errorFields;
  for (let fieldsIndex in errorFields) {
    const errors = errorFields[fieldsIndex].errors;
    for (let errorIndex in errors) {
      errorMsgArray.push(errors[errorIndex]);
    }
  }

  let errorMsg = "";
  for (let msgIndex in errorMsgArray) {
    if ((parseInt(msgIndex) + 1) === errorMsgArray.length) {
      errorMsg += errorMsgArray[msgIndex];
    } else {
      errorMsg += errorMsgArray[msgIndex] + "、";
    }
  }

  message.error("表单校验失败，错误原因：" + errorMsg);
};

const searchFormFinish = async (values) => {

  loading.value = true;

  const result = await globalComponentBatchSelectUsersApi.userInfo({
    waterCompany: values.waterCompany,
    queryCriteria: values.queryCriteria,
    queryContent: values.queryContent
  })
      .then(res => {
        return res.data;
      })
      .catch((error) => {
        const errorMsg = error.response.data.errorMessage;
        Modal.error({
          title: "查询失败",
          content: errorMsg
        });
        throw new Error(errorMsg);
      })
      .finally(() => {
        loading.value = false;
      });

  if (!result.success) {
    Modal.error({title: "查询失败", content: result.errorMessage});
    return;
  }

  userTableData.userInfoList = result.data.userInfoList;
};

const selectOnOk = () => {

  const $userTable = userTableRef.value
  if (!$userTable) {
    message.error("表格未初始化");
    return;
  }

  const selectRecords = $userTable.getCheckboxRecords()
  if (selectRecords.length === 0) {
    message.error("请在表格中勾选需要关联的用户编号");
    return;
  }

  let jsonArray = [];
  for (let index in selectRecords) {
    let json = {};
    json.waterCompany = selectRecords[index].waterCompany;
    json.userNumber = selectRecords[index].userNumber;
    jsonArray.push(json);
  }

  emits("selectFinish", jsonArray);

  open.value = false;

}

const selectOnCancel = () => {

  open.value = false;

}

</script>

<style lang="less" scoped>
@import "index.less";
</style>